import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import useScrollToElement from '@/shared/navigation/useScrollToElement';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import { useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutRadioButton',
  props: {
    name: null,
    disabled: { type: [Boolean, null], default: false },
    value: null,
    modelValue: { default: null },
    isSelected: { type: Boolean },
    label: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { name: string, disabled: boolean | null, value: number, modelValue: any, isSelected: boolean, label: string }





const selectedDeliveryType = useVModel(props, 'modelValue', emit);

const shouldScroll = computed(() => breakpointsState.isBreakpointActive('max-md'));
const shippingIsSelectedAndShouldScroll = computed(() => props.isSelected && shouldScroll.value);
const elToScrollToWhenActive = useScrollToElement(shippingIsSelectedAndShouldScroll, -64);

return (_ctx: any,_cache: any) => {
  const _component_InputRadio = _resolveComponent("InputRadio")!

  return (_openBlock(), _createElementBlock("div", {
    ref: _unref(elToScrollToWhenActive),
    class: "delivery-option mb-x1"
  }, [
    _createVNode(_component_InputRadio, _mergeProps({
      modelValue: _unref(selectedDeliveryType),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedDeliveryType) ? (selectedDeliveryType).value = $event : null)),
      name: __props.name,
      value: __props.value
    }, { ..._ctx.$attrs }, { label: __props.label }), null, 16, ["modelValue", "name", "value", "label"]),
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})